import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@shadcn-in-nx/ui/button";
import { Textarea } from "@shadcn-in-nx/ui/textarea";
import { Loader2, X } from "lucide-react";

export default function DenyReasonForm({ denyReason, setDenyReason, onSubmit, onCancel, isAnalyzing }) {
    const { t } = useTranslation();

    return (
        <div className="space-y-2 p-3 bg-red-50 border border-red-200 rounded-md">
            <label className="text-sm font-medium text-red-700">
                {t("admin.support.denyReasonLabel", "Why was this reply inadequate?")}
            </label>
            <Textarea
                value={denyReason}
                onChange={(e) => setDenyReason(e.target.value)}
                placeholder={t("admin.support.denyReasonPlaceholder", "e.g. Tone was too formal, missing key information...")}
                rows={2}
                className="text-sm"
            />
            <div className="flex gap-2">
                <Button variant="destructive" size="sm" onClick={onSubmit} disabled={isAnalyzing}>
                    {isAnalyzing ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <X className="w-4 h-4 mr-1" />}
                    {t("admin.support.submitDenial", "Submit")}
                </Button>
                <Button variant="ghost" size="sm" onClick={onCancel} disabled={isAnalyzing}>
                    {t("common.cancel", "Cancel")}
                </Button>
            </div>
        </div>
    );
}
